export default "__VITE_ASSET__cdbae571__"